const HTTP_METHODS = {
  GET: 'get',
  POST: 'post',
  PUT: 'put',
};

export default HTTP_METHODS;
